import { map, withLatestFrom, filter } from 'rxjs/operators';
import { path } from '@cbridge-utils/redux';
import { IEpic } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IAuthDependencySegment } from '../_segments/IAuthDependencySegment';
import { AuthAction } from '../auth.action';
import { authStoreSelector } from '../auth.selector';

type IState =
  & IGetSelectorStateType<typeof authStoreSelector>;

type IDependencies = IAuthDependencySegment;

/**
 * Logs out when the auth service reports an unrecoverable refresh failure (LB-2552). Mirrors
 * logoutAuthEventEpic: guarded by isLoggingOut so it does not re-dispatch during an ongoing logout.
 */
export const sessionLostEpic: IEpic<IState, IDependencies> = (_action$, state$, dependencies) => {
  return dependencies.auth.sessionLost$().pipe(
    withLatestFrom(state$),
    filter(([, state]) => !path(authStoreSelector).isLoggingOut()(state)),
    map(() => {
      return AuthAction.logout();
    }),
  );
};
